export const IceCream = ({ title }: { title: string }) => (
	<svg width="100%" viewBox="0 0 503 503" fill="none" xmlns="http://www.w3.org/2000/svg" role="img">
		<title>{title}</title>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M406.429 437C442.722 398.878 465 347.291 465 290.5C465 173.139 369.861 78 252.5 78C135.139 78 40 173.139 40 290.5C40 347.291 62.2777 398.878 98.5709 437H406.429Z"
			fill="#D4E3FC"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M118.432 65.2069C119.659 63.3962 122.331 62.7019 124.322 64.3507L288.471 200.314C290.263 201.798 290.299 204.212 289.122 205.802C295.904 211.65 301.837 218.718 306.569 226.911C318.696 247.907 320.481 272.039 313.502 293.406C333.618 297.726 352.138 309.574 364.467 328.035C378.724 349.382 381.641 374.99 374.635 397.75C376.055 398.632 377 400.205 377 402C377 404.761 374.762 407 372 407C371.726 407 371.457 406.978 371.196 406.936C369.208 411.411 366.812 415.726 364.02 419.819C380.504 428.982 374.357 451.591 359.735 450.746C350.327 450.202 346.524 451.73 338.877 454.805L338.877 454.805L338.877 454.805L338.876 454.806L338.876 454.806C334.062 456.741 327.726 459.288 317.51 462.317C298.591 467.925 289.435 462.125 280.751 456.624L280.751 456.623C278.29 455.064 275.866 453.529 273.27 452.285C271.684 451.822 270.112 451.312 268.555 450.754C260.46 453.032 256.116 456.868 251.505 460.94C246.673 465.207 241.547 469.734 231.5 472.999C220.592 476.544 215.187 473.397 209.851 470.289C205.402 467.699 201.001 465.136 193.5 466.5C177 469.5 156 470.5 153 457.5C150 444.5 157.5 430.5 187 429.5C200.909 429.028 210.372 431.113 217.642 432.715C224.122 434.143 228.86 435.187 233.451 433.695C234.264 432.418 235.299 431.122 236.585 429.818C233.595 426.637 230.821 423.175 228.302 419.44C227.613 419.798 226.83 420 226 420C223.239 420 221 417.761 221 415C221 413.266 221.883 411.738 223.224 410.841C222.059 408.565 221.011 406.253 220.077 403.915C217.756 403.482 216 401.446 216 399C216 397.715 216.485 396.543 217.282 395.657C212.873 379.893 213.366 363.319 218.333 348.093C196.478 343.389 176.617 329.819 164.555 308.935C159.689 300.512 156.489 291.583 154.851 282.531C152.601 284.427 148.882 283.261 148.352 280.105L123.847 133.988C123.686 133.963 123.529 133.899 123.39 133.793C122.953 133.456 122.871 132.828 123.207 132.39L123.512 131.994L113.05 69.6129C112.514 66.4138 115.711 64.1333 118.432 65.2069ZM400 449C400 451.761 397.762 454 395 454C392.239 454 390 451.761 390 449C390 446.238 392.239 444 395 444C397.762 444 400 446.238 400 449Z"
			fill="white"
		/>
		<g style={{ mixBlendMode: 'multiply' }}>
			<circle cx="226" cy="415" r="5" fill="#1A6BE6" />
		</g>
		<g style={{ mixBlendMode: 'multiply' }}>
			<circle cx="372" cy="402" r="5" fill="#FB5B63" />
		</g>
		<g style={{ mixBlendMode: 'multiply' }} opacity="0.8">
			<path
				d="M113.05 69.613C112.438 65.9667 116.677 63.5137 119.534 65.8606L236.221 161.719C237.844 163.052 238.159 165.413 236.943 167.125L155.558 281.759C153.493 284.667 148.942 283.623 148.352 280.105L113.05 69.613Z"
				fill="#F2CB8B"
			/>
		</g>
		<g style={{ mixBlendMode: 'multiply' }} opacity="0.8">
			<path
				d="M124.322 64.3507C121.467 61.9864 117.21 64.4404 117.826 68.0954L142.867 216.81C143.214 218.874 145.093 220.321 147.177 220.13L286.284 207.378C289.837 207.052 291.218 202.59 288.471 200.314L124.322 64.3507Z"
				fill="#F2CB8B"
			/>
		</g>
		<path d="M215 144L151 228" stroke="#EDD0A0" strokeWidth="2" strokeLinecap="round" />
		<path d="M195 127L137 203" stroke="#EDD0A0" strokeWidth="2" strokeLinecap="round" />
		<path d="M175 111L133 166" stroke="#EDD0A0" strokeWidth="2" strokeLinecap="round" />
		<path d="M154 94L124 133" stroke="#EDD0A0" strokeWidth="2" strokeLinecap="round" />
		<path d="M137 80L120 102" stroke="#EDD0A0" strokeWidth="2" strokeLinecap="round" />
		<g style={{ mixBlendMode: 'multiply' }}>
			<circle cx="235.562" cy="267.923" r="82" transform="rotate(149.99 235.562 267.923)" fill="#FDAAAF" />
		</g>
		<g style={{ mixBlendMode: 'multiply' }}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M313.503 293.406C307.447 311.947 294.794 328.407 276.574 338.93C258.242 349.519 237.519 352.223 218.333 348.093C223.836 331.222 234.832 316.007 250.735 305.386C269.935 292.563 292.581 288.913 313.503 293.406Z"
				fill="#FECDCF"
			/>
		</g>
		<path d="M134.752 189.831L239.62 177.388" stroke="#EDD0A0" strokeWidth="2" strokeLinecap="round" />
		<path d="M130.273 163.967L225.201 152.628" stroke="#EDD0A0" strokeWidth="2" strokeLinecap="round" />
		<path d="M126.654 138.611L195.365 130.383" stroke="#EDD0A0" strokeWidth="2" strokeLinecap="round" />
		<path d="M122.682 111.886L171.516 105.863" stroke="#EDD0A0" strokeWidth="2" strokeLinecap="round" />
		<path d="M119.262 90.1308L146.848 86.6671" stroke="#EDD0A0" strokeWidth="2" strokeLinecap="round" />
		<g style={{ mixBlendMode: 'multiply' }}>
			<path d="M282.021 440.578C298.048 443.042 335.052 443.938 354.846 427.817C335.223 449.639 315.297 451.438 282.021 440.578Z" fill="#DBE1E6" />
		</g>
		<circle cx="325" cy="432" r="5" fill="#725CFF" />
		<circle cx="299" cy="439" r="5" fill="#FB5B63" />
		<circle cx="247" cy="383" r="5" fill="#FB5B63" />
		<circle cx="174" cy="432" r="5" fill="#FB5B63" />
		<circle cx="330" cy="419" r="5" fill="#1A6BE6" />
		<circle cx="225" cy="459" r="5" fill="#1A6BE6" />
		<circle cx="221" cy="399" r="5" fill="#725CFF" />
		<circle cx="266" cy="419" r="5" fill="#FFBA1A" />
		<g style={{ mixBlendMode: 'multiply' }}>
			<circle cx="182" cy="434" r="5" fill="#FFBA1A" />
		</g>
		<circle cx="242" cy="430" r="5" fill="#16AC52" />
		<circle cx="344" cy="424" r="5" fill="#16AC52" />
		<circle cx="345" cy="394" r="5" fill="#FFBA1A" />
		<circle cx="395" cy="449" r="5" fill="#FFBA1A" />
		<circle cx="296" cy="405" r="5" fill="#16AC52" />
	</svg>
);
